<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Ingresos únicos</span>
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
      <mat-form-field appearance="outline" style="width: 400px;">
        <mat-label>Periodo de busqueda</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Fecha desde" />
          <input matEndDate [(ngModel)]="endDate" placeholder="Fecha hasta" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
  
      <button style="margin-left: 10px;" (click)='buscar()' mat-raised-button color="primary">Buscar</button>
    </div>
  
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>

    <mat-card *ngIf="numIngresosUnicos>-1">Ingresos únicos totales: {{numIngresosUnicos}}</mat-card>
  
    <mat-form-field appearance="outline" >
      <mat-label>Filtro</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
    </mat-form-field>
  
    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
      <table mat-table [dataSource]="dataSource">

  
        <ng-container matColumnDef="empresa">
          <th mat-header-cell *matHeaderCellDef>Club</th>
          <td mat-cell *matCellDef="let element">{{ element.empresa }}</td>
        </ng-container>

        <ng-container matColumnDef="cantidad">
            <th mat-header-cell *matHeaderCellDef>Cantidad</th>
            <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
          </ng-container>

  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
      <mat-paginator
        #paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="getServerData($event)"
      ></mat-paginator>
    </div>
  </div>
  